import { orgInitials, orgMarkTone } from "~/lib/company-stack";

type Props = {
  name: string;
  size?: "sm" | "lg";
};

export function OrgMark(props: Props) {
  const size = () => props.size ?? "sm";
  return (
    <div
      class={`company-mark company-mark--${size()} company-mark--${orgMarkTone(props.name)}`}
      aria-hidden="true"
    >
      {orgInitials(props.name)}
    </div>
  );
}
